import { ACTIONS } from "./../constants"


const initialState = { 
  contractAgreements: [], 
  contractAgreement: {}, 
  file: null,
  totalSize: 0,
  isFetching: false, 
  isLoading: false,
  hasMore: true, 
  success: false,
  error: null
}


export default (state = initialState , action) => {
  const { payload, type } = action
  switch (type) {

    case ACTIONS.CLEAR_CONTRACT_AGREEMENT : {
      return { ...state, success: false, error: null, isFetching: false, isLoading: false }
    }

    case ACTIONS.FETCH_CONTRACT_AGREEMENTS_INIT : {
      return { ...state, isFetching: true, success: false, error: null }
    }
    case ACTIONS.FETCH_CONTRACT_AGREEMENTS_SUCCEDED : {
      const { count, results } = payload
      return { ...state, totalSize: count, contractAgreements: results, isFetching: false, error: null }
    }
    case ACTIONS.FETCH_CONTRACT_AGREEMENTS_FAILED : {
      return { ...state, isFetching: false, error: payload }
    }

    case ACTIONS.FETCH_DOCUMENT_INIT : {
      return { ...state, isLoading: true, error: null }
    }
    case ACTIONS.FETCH_DOCUMENT_SUCCEDED : {
      return { ...state, file: payload, isLoading: false, error: null }
    }
    case ACTIONS.FETCH_DOCUMENT_FAILED : {
      return { ...state, isLoading: false, error: payload }
    }

    case ACTIONS.CREATE_CONTRACT_AGREEMENT_INIT : {
      return { ...state, isLoading: true, error: null, success: false }
    }
    case ACTIONS.CREATE_CONTRACT_AGREEMENT_SUCCEDED : {
      return { ...state, success: true, isLoading: false, error: null }
    }
    case ACTIONS.CREATE_CONTRACT_AGREEMENT_FAILED : {
      return { ...state, error: payload, isLoading: false, success: false }
    }

    case ACTIONS.EDIT_CONTRACT_AGREEMENT_INIT : {      
      return { ...state, isLoading: true, error: null, success:false }
    }
    case ACTIONS.EDIT_CONTRACT_AGREEMENT_SUCCEDED : {
      return { ...state, contractAgreement: payload, success: true, isLoading: false, error: null }
    }
    case ACTIONS.EDIT_CONTRACT_AGREEMENT_FAILED : {
      return { ...state, error: payload, isLoading: false, success: false }
    }
 
    case ACTIONS.FETCH_CONTRACT_AGREEMENT_INIT : {
      return { ...state, isFetching: true, contractAgreement: null, error: null }
    }
    case ACTIONS.FETCH_CONTRACT_AGREEMENT_SUCCEDED : {
      return { ...state, contractAgreement: { ...payload, file: payload.fileUrl && `${payload.thematicFr}.pdf`}, isFetching: false, error: null }
    }
    case ACTIONS.FETCH_CONTRACT_AGREEMENT_FAILED : {
      return { ...state, isFetching: false, error: payload }
    }

    case ACTIONS.DISABLE_CONTRACT_AGREEMENT_INIT : {
      return { ...state, isLoading: true, success: false, error: null }
    }
    case ACTIONS.DISABLE_CONTRACT_AGREEMENT_SUCCEDED : {
      return { ...state, success: true, isLoading: false, error: null }
    }
    case ACTIONS.DISABLE_CONTRACT_AGREEMENT_FAILED : {
      return { ...state, isLoading: false, error: payload }
    }

    case ACTIONS.DISABLE_CONTRACT_AGREEMENTS_INIT : {
      return { ...state, isLoading: true, success: false, error: null }
    }
    case ACTIONS.DISABLE_CONTRACT_AGREEMENTS_SUCCEDED : {
      return { ...state, success: true, isLoading: false, error: null }
    }
    case ACTIONS.DISABLE_CONTRACT_AGREEMENTS_FAILED : {
      return { ...state, isLoading: false, error: payload }
    }

    case ACTIONS.ENABLE_CONTRACT_AGREEMENT_INIT : {
      return { ...state, isLoading: true, success: false, error: null }
    }
    case ACTIONS.ENABLE_CONTRACT_AGREEMENT_SUCCEDED : {
      return { ...state, success: true, isLoading: false, error: null }
    }
    case ACTIONS.ENABLE_CONTRACT_AGREEMENT_FAILED : {
      return { ...state, isLoading: false, error: payload }
    }
    
    case ACTIONS.ENABLE_CONTRACT_AGREEMENTS_INIT : {
      return { ...state, isLoading: true, success: false, error: null }
    }
    case ACTIONS.ENABLE_CONTRACT_AGREEMENTS_SUCCEDED : {
      return { ...state, success: true, isLoading: false, error: null }
    }
    case ACTIONS.ENABLE_CONTRACT_AGREEMENTS_FAILED : {
      return { ...state, isLoading: false, error: payload }
    }

    default: {
      return state
    }
  }
}
